import "./settings.css";
import { AdminPageHeader, AdminCard } from "../../components/ui";

const ROLES = [
  {
    name: "Admin",
    description: "Full access: everything Staff can do, plus creating other Staff/Admin-managed data with no additional restriction.",
    permissions: [
      "Manage products, categories, brands, tags, and inventory",
      "Manage orders, cancellations, and returns/refunds",
      "Manage coupons and homepage banners",
      "Manage staff and customer accounts",
      "View sales analytics and the activity log",
    ],
  },
  {
    name: "Staff",
    description: "Day-to-day store operations - the same operational access as Admin, minus account types Staff can't create.",
    permissions: [
      "Manage products, categories, brands, tags, and inventory",
      "Manage orders, cancellations, and returns/refunds",
      "Manage coupons and homepage banners",
      "Manage customer accounts and create new Staff/Delivery accounts (never Admin)",
      "View sales analytics and the activity log",
    ],
  },
  {
    name: "Delivery",
    description: "A delivery-only account type - not currently granted any admin panel access.",
    permissions: [
      "No admin panel access",
    ],
  },
  {
    name: "Customer",
    description: "The storefront account type - no admin panel access at all.",
    permissions: [
      "Manage their own profile, address book, orders, wishlist, and reviews",
    ],
  },
];

function Settings() {
  return (
    <div>
      <AdminPageHeader
        title="Roles & Permissions"
        subtitle="A read-only reference for what each account type can do."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Settings" }]}
      />
      <div className="settingsRoles">
        {ROLES.map((role) => (
          <AdminCard key={role.name} className="settingsRoleCard">
            <h2>{role.name}</h2>
            <p className="settingsRoleDescription">{role.description}</p>
            <ul>
              {role.permissions.map((perm) => (
                <li key={perm}>{perm}</li>
              ))}
            </ul>
          </AdminCard>
        ))}
      </div>
    </div>
  );
}

export default Settings
